import React from "react";
import styled from "styled-components/macro";
import { rem } from "polished";

import media from "../theme/media";

import { Note } from "./FormNote";
import Info from "./Info";
import processHelpText from "../helpers/processHelpText";
import ReactMarkdown from "react-markdown";

const FormLabel: React.FunctionComponent<{
  text: string;
  name?: string;
}> = React.memo(
  ({ text, name, children }) => {
    const helpTextLabel = processHelpText(text);
    const labelText = React.useMemo(() => {
      if (typeof text === "string") {
        return <ReactMarkdown source={text} renderers={{ paragraph: 'span' }} linkTarget="_blank" />;
      }
      return text;
    }, [text]);

    if (helpTextLabel) {
      let { after, before } = helpTextLabel;

      return (
        <Label htmlFor={name} name={name}>
          {before && before}
          <Info inherit string="" {...helpTextLabel} />
          {after && after}
          {children}
        </Label>
      );
    }
    return (
      <Label htmlFor={name}>
        {labelText}
        {children}
      </Label>
    );
  },
  (p, n) => {
    return true;
  }
);

export default FormLabel;

export const Label = styled.label<{ name?: string }>`
  display: block;
  font-size: ${rem(17)};
  font-weight: bold;
  color: #3c3c3c;
  margin-bottom: ${rem(8)};
  font-weight: 600;
  position: relative;

  em {
    font-weight: 300;
  }

  ${Note} {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }

  ${media.greaterThan("tablet")`
    font-size: ${rem(18)};
  `}
`;
